import { WEBINAR_TIMEZONE } from "../constants";
import { SessionMode, SessionSaveAction } from "../types/actions";
import { SessionSaveDto } from "../types/dto";
import { SessionFormState } from "../utils/sessionFormState";
import { deriveStartAt } from "../utils/deriveStartAt";

export type BuildSessionPayloadOptions = {
  mode: SessionMode;
  action: SessionSaveAction;
};

export function buildSessionPayload(
  form: SessionFormState,
  { mode, action }: BuildSessionPayloadOptions
): SessionSaveDto {
  const { startAt, start } = deriveStartAt(form.date, form.time);
  const status = action === "draft" ? "draft" : "scheduled";

  // After first POST, form.id is set even in create/duplicate — include it for PATCH.
  const id = form.id || undefined;

  if (mode === "edit" && form.currentStatus === "scheduled" && action === "draft") {
    throw new Error("Cannot save a scheduled session as draft");
  }

  const isRescheduled =
    mode === "edit" &&
    form.currentStatus === "scheduled" &&
    typeof form.origStart === "number" &&
    Number.isFinite(start) &&
    start !== form.origStart;

  return {
    id,
    title: form.title.trim(),
    oneLiner: form.oneLiner.trim(),
    fullDesc: form.fullDesc.trim(),
    takeaways: form.takeaways.map((t) => t.trim()).filter(Boolean),
    topicId: form.topicId,
    hostId: form.hostId,
    date: form.date,
    time: form.time,
    timezone: WEBINAR_TIMEZONE,
    startAt,
    mins: Number(form.mins) || 45,
    access: form.access,
    cohorts: form.access === "members" ? [...form.cohorts] : [],
    lang: form.lang || "English",
    format: form.format,
    provider: form.provider,
    joinUrl: form.joinUrl.trim(),
    recurrence: form.recurrence || "none",
    recEnd: form.recurrence !== "none" ? form.recEnd || undefined : undefined,
    status,
    ...(isRescheduled ? { isRescheduled: true } : {}),
  };
}
